import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	more: {
		id: 'search.common.icons.all-apps.more',
		defaultMessage: 'more',
		description: 'Label to signify that a user can search for more connected apps',
	},
});
